import { store } from '@betacrew/jars-flux';
import { all, put, takeLatest } from 'redux-saga/effects';
import PayerDataService from '../../../../services/PayerDataService';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import { PAGE_STATE } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { componentKey, setIsSaveIntermediarySuccessful, setLoadingState, updateAddIntermediaryDataObj,  } from './IntermediarySlice';

export const { submitSaveIntermediary, getIntermediaryDetails } = {
    submitSaveIntermediary: (payload) => {
        return {
            type: "INTERMEDIARY/SAVE",
            payload: payload
        }
    },
    getIntermediaryDetails: (payload) => {
        return {
            type: "INTERMEDIARY/GET_DETAILS",
            payload: payload
        }
    },
}

function* submitSaveIntermediaryAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));
        const response = yield PayerDataService.saveIntermediary(action.payload);
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
        if(response.data.Status){
            yield put(setIsSaveIntermediarySuccessful(true));
            yield put(addNotifications({
                heading: "Success",
                message: response.data.Message,
                variant: TOASTER_VARIANT.SUCCESS
            }));
        }else{
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    }catch {
        yield put(addNotifications({
            heading: "Error",
            message: "Invalid request. Please try again.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* getIntermediaryDetailsAsync(action) {
    try {
        yield put(setLoadingState({ state: PAGE_STATE.LOADING }));

        const {id, countriesList, statesList} = action.payload;
        const response = yield PayerDataService.getIntermediaryDetails(id);
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
        const { Message, Status, Data } = response?.data;
        if(Status){
            const country = countriesList?.find(country => country?.Country_code === Data?.IntermediaryCountryCode);

            let state = { label: Data?.IntermediaryState,  value: Data?.IntermediaryState};
            if (Data?.Country_code === "US") {
                state = statesList.find(state => state.StateAbbreviation === Data?.IntermediaryState);
            }

            yield put(updateAddIntermediaryDataObj({
                IntermediaryId: { value: Data?.IntermediaryId || "" },
                Name: { value: Data?.IntermediaryName || "" },
                Address: { value: Data?.IntermediaryAddress || "" },
                CountryCode: country,
                StateorProvinceCode: state,
                City: { value: Data?.IntermediaryCity || "" },
                ZipCode: { value: Data?.IntermediaryZipCode || "" },
                TIN: { value: Data?.IntermediaryTIN || "" },
                FTIN: { value: Data?.IntermediaryFTIN || "" },
                GIIN: { value: Data?.IntermediaryGIIN || "" },
            }));
        }else{
            yield put(addNotifications({
                heading: "Error",
                message: Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
    }catch {
        yield put(addNotifications({
            heading: "Error",
            message: "Invalid request. Please try again.",
            variant: TOASTER_VARIANT.DANGER
        }));
    } finally {
        yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
    }
}

function* rootSaga() {
    yield all([
        takeLatest(submitSaveIntermediary().type, submitSaveIntermediaryAsync),
        takeLatest(getIntermediaryDetails().type, getIntermediaryDetailsAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);